import { useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://static.wixstatic.com/media/58bce5_d3b328734c704962ade71ba5f7a8c4de~mv2.png";

const navItems = [
  { label: "Kezdőoldal", to: "/" },
  { label: "Munkáink", to: "/munkaink" },
  { label: "Rólunk", to: "/rolunk" },
  { label: "Kapcsolat", to: "/#kapcsolat", isHash: true },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleContact = (e) => {
    e.preventDefault();
    setOpen(false);
    if (location.pathname === "/") {
      const scroll = () =>
        document.querySelector("#kapcsolat")?.scrollIntoView({ behavior: "smooth", block: "start" });
      scroll();
      // Korrekció: a lazy képek betöltése elcsúsztathatja az oldalt
      setTimeout(scroll, 700);
      setTimeout(scroll, 1500);
    } else {
      navigate("/#kapcsolat");
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-[var(--bg-dark)]">
      <div className="mx-auto flex items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <img src={LOGO_URL} alt="New Idea Architect logó" className="h-10 w-10 object-contain" />
          <span className="font-light tracking-wide text-white text-xl sm:text-2xl whitespace-nowrap" style={{ fontFamily: "'Inter Tight', sans-serif", fontWeight: 300 }}>
            New Idea Architect
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-stretch gap-1.5">
          {navItems.map((item) =>
            item.isHash ? (
              <a
                key={item.label}
                href="/#kapcsolat"
                onClick={handleContact}
                className="px-5 py-2.5 text-sm font-semibold rounded-md border border-white/20 bg-white text-black hover:bg-[var(--accent)] transition-colors duration-200"
              >
                {item.label}
              </a>
            ) : (
              <NavLink
                key={item.label}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-5 py-2.5 text-sm font-semibold rounded-md border transition-colors duration-200 ${
                    isActive
                      ? "bg-[var(--accent)] text-black border-[var(--accent)]"
                      : "bg-white text-black border-white/20 hover:bg-[var(--accent)]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            )
          )}
        </nav>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menü"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile nav */}
      {open && (
        <nav className="md:hidden flex flex-col gap-2 px-4 pb-4">
          {navItems.map((item) =>
            item.isHash ? (
              <a
                key={item.label}
                href="/#kapcsolat"
                onClick={handleContact}
                className="px-5 py-3 text-sm font-semibold rounded-md bg-white text-black text-center"
              >
                {item.label}
              </a>
            ) : (
              <NavLink
                key={item.label}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-5 py-3 text-sm font-semibold rounded-md text-center ${
                    isActive ? "bg-[var(--accent)] text-black" : "bg-white text-black"
                  }`
                }
              >
                {item.label}
              </NavLink>
            )
          )}
          <a
            href="/#kapcsolat"
            onClick={handleContact}
            className="px-5 py-3.5 text-sm font-bold rounded-md bg-[var(--accent)] text-black text-center"
          >
            ÁRAJÁNLATKÉRÉS
          </a>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
